import React, { useEffect } from "react";
import {
  AnswerTitleBlock,
  GalleryBlock,
  WhyContainer,
  WhyImportantBlock,
  WhyServiceDescription,
  WhyServiceTitle,
  AnswerBlock,
  MoreButton,
  MoreButtonContainer,
  GalleryImage,
} from "./style";
import "./style.css";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
// ..
import { graphql, useStaticQuery } from "gatsby";

const Why = () => {
  const data = useStaticQuery(graphql`
    query {
      allFile(
        filter: { ext: { regex: "/jpg/" }, name: { in: ["portfolioBaner"] } }
      ) {
        edges {
          node {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
              id
            }
          }
        }
      }
    }
  `);
  useEffect(() => {
    AOS.init({
      duration: 600,
    });
    AOS.refresh();
  }, []);
  const imageFluid = data.allFile.edges[0].node.childImageSharp.fluid;
  return (
    <WhyContainer
      data-aos="zoom-in"
      data-aos-offset="100"
      data-aos-delay="20"
      data-aos-easing="ease-in-out"
      data-aos-mirror="true"
      data-aos-once="false"
      data-aos-anchor-placement="top-bottom">
      <WhyImportantBlock
        data-aos="zoom-in"
        data-aos-offset="100"
        data-aos-delay="20"
        data-aos-easing="ease-in-out"
        data-aos-mirror="true"
        data-aos-once="false"
        data-aos-anchor-placement="top-bottom">
        <WhyServiceTitle>Why these services are important?</WhyServiceTitle>

        <WhyServiceDescription
          data-aos="zoom-in"
          data-aos-offset="100"
          data-aos-delay="20"
          data-aos-easing="ease-in-out"
          data-aos-mirror="true"
          data-aos-once="false"
          data-aos-anchor-placement="top-bottom">
          <AnswerTitleBlock>Frontend</AnswerTitleBlock>
          <AnswerBlock>
            A good fontend attract more people in your business and good ui
            makes you more professional.
          </AnswerBlock>
        </WhyServiceDescription>
        <WhyServiceDescription
          data-aos="zoom-in"
          data-aos-offset="100"
          data-aos-delay="20"
          data-aos-easing="ease-in-out"
          data-aos-mirror="true"
          data-aos-once="false"
          data-aos-anchor-placement="top-bottom">
          <AnswerTitleBlock>Backend</AnswerTitleBlock>
          <AnswerBlock>
            Backend technologies are meant to be make easier and logical
            business solutions. It's main purpose is to help your frontend and
            make analytical decision. Provide you your need what others can't
            see.
          </AnswerBlock>
        </WhyServiceDescription>
        <WhyServiceDescription
          data-aos="zoom-in"
          data-aos-offset="100"
          data-aos-delay="20"
          data-aos-easing="ease-in-out"
          data-aos-mirror="true"
          data-aos-once="false"
          data-aos-anchor-placement="top-bottom">
          <AnswerTitleBlock>Mobile</AnswerTitleBlock>
          <AnswerBlock>
            Suppose you have your own app that can manage your users, your
            business, your client and other internal services. And you want to
            get more business. So what's better than your service based moble
            app?
          </AnswerBlock>
        </WhyServiceDescription>
        <WhyServiceDescription
          data-aos="zoom-in"
          data-aos-offset="100"
          data-aos-delay="20"
          data-aos-easing="ease-in-out"
          data-aos-mirror="true"
          data-aos-once="false"
          data-aos-anchor-placement="top-bottom">
          <AnswerTitleBlock>Maintanace</AnswerTitleBlock>
          <AnswerBlock>
            You are faceing version issue? Your site or app or technology is not
            woking properly? You Don't have to go for new application, if it can
            be fixed and well maintained!
          </AnswerBlock>
        </WhyServiceDescription>
        <MoreButtonContainer
          data-aos="zoom-in"
          data-aos-offset="100"
          data-aos-delay="20"
          data-aos-easing="ease-in-out"
          data-aos-mirror="true"
          data-aos-once="false"
          data-aos-anchor-placement="top-bottom">
          <MoreButton to="/">More ...</MoreButton>
        </MoreButtonContainer>
      </WhyImportantBlock>
      <GalleryImage
        fluid={imageFluid}
        data-aos="zoom-in"
        data-aos-offset="100"
        data-aos-delay="20"
        data-aos-easing="ease-in-out"
        data-aos-mirror="true"
        data-aos-once="false"
        data-aos-anchor-placement="top-bottom"
      />
    </WhyContainer>
  );
};

export default Why;
